import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loader from '../../components/common/Loader';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  console.log('🔒 ProtectedRoute - user:', user, 'loading:', loading);

  // Afficher le loader pendant la vérification
  if (loading) {
    return <Loader />;
  }

  // Rediriger vers login si non authentifié
  if (!user) {
    console.log('➡️ Redirection vers login - utilisateur non connecté');
    return <Navigate to="/login" replace />;
  }

  // Afficher la page protégée
  return children;
};

export default ProtectedRoute;